module.exports = __webpack_public_path__ + "img/iconuser.a4e67269.svg";